/**
 * Admin Brand Management — `/admin/brands`
 *
 * Every team's brands in one table with colour swatch, product count, search, edit and
 * soft-delete. Backed by the `adminBrands` tRPC router.
 *
 * Distinct from `/brands`, which is the team-scoped brand kit editor.
 *
 * @feature-spec brain/vidmax/feature-specs/admin-brands.md
 */
import { createFileRoute } from "@tanstack/react-router"
import type { ReactElement } from "react"

import { AdminBrandList } from "~/components/Admin/AdminBrandList"
import CustomHead from "~/components/SEOHead/CustomHead"
import { SuperAdminLayout } from "~/layouts/SuperAdminLayout"

function AdminBrands(): ReactElement {
  return (
    <>
      <CustomHead title="All Brands" />
      <div>
        <AdminBrandList />
      </div>
    </>
  )
}

function AdminBrandsWrapper(): ReactElement {
  return (
    <SuperAdminLayout>
      <AdminBrands />
    </SuperAdminLayout>
  )
}

export const Route = createFileRoute("/admin/brands")({
  component: AdminBrandsWrapper,
})
